export function localDate(value: string) {
  const [date, time = "00:00:00"] = value.split("T");
  const [year, month, day] = date.split("-").map(Number);
  const [hour, minute, second] = time.split(":").map(Number);
  return new Date(year, month - 1, day, hour, minute, second || 0);
}
export const formatLocalDate = (value: string) => localDate(value).toLocaleDateString("fa-IR");
export function dateRange(days: number, now = new Date()) {
  const to = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const from = new Date(to); from.setDate(from.getDate() - days);
  const iso = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  return { fromDate: iso(from), toDate: iso(to) };
}
export const weekdayOrder = [6, 0, 1, 2, 3, 4, 5];
